module.exports = __webpack_public_path__ + "static/media/Residential_57.20994d3e.jpg";